import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "map-marker-content-city token-text-mediumbold" }
const _hoisted_3 = {
  key: 0,
  class: "map-marker-content-price token-text-medium no-text-wrap"
}
const _hoisted_4 = { class: "map-group-marker-size" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mx-auto d-flex" }
const _hoisted_7 = { class: "map-marker-content-city token-text-mediumbold" }
const _hoisted_8 = {
  key: 0,
  class: "map-marker-content-price token-text-medium no-text-wrap"
}
const _hoisted_9 = { ref: "searchCountry" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!

  return (_openBlock(), _createElementBlock("div", {
    class: "map-wrap",
    style: _normalizeStyle(
      'width: ' +
      (_ctx.width ? _ctx.width : '100%') +
      '; height: ' +
      (_ctx.height ? _ctx.height : '100%')
    )
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markers, (marker, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "map-marker d-flex-col",
        key: 'map-marker-' + index,
        ref_for: true,
        ref: 'map-marker-' + index
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["map-marker-wrapper", {
          selected: marker.selected,
          hidden: _ctx.showGroupedMarkers,
          disabled: marker.disabled,
        }])
        }, [
          _createVNode(_component_Tooltip, {
            hoverOnly: true,
            disabled: !marker.disabled,
            class: "full-width"
          }, {
            target: _withCtx(() => [
              _createElementVNode("div", {
                class: "map-marker-content",
                onClick: ($event: any) => {if (!marker.disabled) _ctx.$emit('clickMapMarker', marker);}
              }, [
                _createVNode(_component_Logo, {
                  logo: marker.provider,
                  class: "mx-auto"
                }, null, 8, ["logo"]),
                _createElementVNode("div", _hoisted_2, _toDisplayString(marker.city), 1),
                (marker.price !== Infinity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (marker.price)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString("From " +
                  _ctx.$helpers.prices.format(marker.price, marker.currency, 0)), 1)
                          ], 64))
                        : (_openBlock(), _createBlock(_component_Spinner, {
                            key: 1,
                            light: marker.selected
                          }, null, 8, ["light"]))
                    ]))
                  : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "map-marker-background" }, null, -1))
              ], 8, _hoisted_1)
            ]),
            content: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" This location is temporarily unavailable."),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" This can be due to a lack of server availability, or you might need to connect your own account for that cloud provider. ")
            ])),
            _: 2
          }, 1032, ["disabled"]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "map-marker-point mt-1 mx-auto" }, null, -1))
        ], 2)
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupMarkers, (marker, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "map-marker d-flex-col",
        key: 'map-marker-' + index,
        ref_for: true,
        ref: 'map-group-marker-' + index
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["map-marker-wrapper", { selected: marker.selected, hidden: !_ctx.showGroupedMarkers }])
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(marker.groupSize), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.min(marker.groupSize || 1, 3), (i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `map-marker-spacer-${index}-${i}`,
              class: _normalizeClass(`map-marker-content map-marker-content-${i}`),
              onClick: ($event: any) => (
            _ctx.onSelectCountry({
              text: marker.city,
              value: marker.id,
              meta: {
                latitude: marker.lat,
                longitude: marker.lng,
              },
            })
          )
            }, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marker.provider, (provider) => {
                  return (_openBlock(), _createBlock(_component_Logo, {
                    key: `${marker.id}-${provider}`,
                    logo: provider,
                    class: "fit-content"
                  }, null, 8, ["logo"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(marker.city), 1),
              (marker.price !== Infinity)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (marker.price)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString("From " + _ctx.$helpers.prices.format(marker.price, marker.currency, 0)), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_Spinner, {
                          key: 1,
                          light: marker.selected
                        }, null, 8, ["light"]))
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "map-marker-point mt-1 mx-auto" }, null, -1))
        ], 2)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_CountrySelector, {
        selectedCountry: _ctx.selectedCountry,
        onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelectCountry($event)))
      }, null, 8, ["selectedCountry"])
    ], 512),
    _cache[5] || (_cache[5] = _createElementVNode("div", null, [
      _createElementVNode("div", {
        id: "map",
        class: "map"
      })
    ], -1))
  ], 4))
}